// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	//Api Weather
	weather()

	//Burgeer Menu
	const burger_CTAS  = document.querySelectorAll("[data-ctaburger]");
	const burger_Content = document.querySelector("[data-menuburger]");

	burger_CTAS.forEach(currentItem => {
		currentItem.addEventListener('click', (e) =>{
			e.preventDefault();
			burger_Content.classList.toggle("open");
			document.body.classList.toggle("no-scroll");
		});
	});

	if (window.innerWidth <= 900) {
		const menu_Items = document.querySelectorAll("[data-menuburger] #privary-navigation li:has(.submenu)");

		let prevMenuItem;

		menu_Items.forEach( element => {

			// active for link generate in js
			const Main_Link = element.querySelector("a");
			const Link_url = Main_Link.href;
			const newListItem = `
			<li class="privary-navigation__item ovv">
				<a tabindex="-1" aria-haspopup="false"  href="${Link_url}">overview</a>
			</li>`;

			Main_Link.nextElementSibling.insertAdjacentHTML("afterbegin", newListItem);

			// active for link generate in js
			if (Main_Link.classList.contains("active")) {
				Main_Link.nextElementSibling.querySelector("a").classList.add("active");
			}

			if ([... Main_Link.nextElementSibling.querySelectorAll("a")].some(item => item.classList.contains("active"))) {
				Main_Link.nextElementSibling.classList.add("active")
			}

			Main_Link.addEventListener('click', (e) =>{
				e.preventDefault();
				if (prevMenuItem && prevMenuItem != e.target.nextElementSibling) prevMenuItem.classList.remove('active');
				e.target.nextElementSibling.classList.toggle("active");
				prevMenuItem = e.target.nextElementSibling;
			});
		});
	}

	window.onload = function () {
		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
	};

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
	//email signup animation
	const allInputsSignUp = document.querySelectorAll(".email-signup .input input")
	if (allInputsSignUp) {
		allInputsSignUp.forEach(input => {
			input.addEventListener('focus', function () {
				this.parentElement.classList.add('moved');
			});
		});
	}

	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		let allffields = document.getElementsByClassName('form-module__field');

		for (let j = 0; j < allffields.length; j++) {

			if (allffields[j].getElementsByTagName('input').length > 0) {
				if (allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					})
				}
			}
			if (allffields[j].getElementsByTagName('select').length > 0) {
				allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				})
			}
			if (allffields[j].getElementsByTagName('textarea').length > 0) {
				allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				})
			}
		}
	}
	//Api Clime

	function weather() {
		const append_Content = document.querySelector('[data-timewidget]')

		const WEATHER_API_CONF = {
			api_key: "0ddd1af8b5b1833cedd6da7a90934cce",
			unit: "imperial",
			lat: 35.445,
			lon: -82.811,
			getter: "https://api.openweathermap.org/data/2.5/weather"
		}

		const url_Fetch = `${WEATHER_API_CONF.getter}?lat=${WEATHER_API_CONF.lat}&lon=${WEATHER_API_CONF.lon}&units=${WEATHER_API_CONF.unit}&appid=${WEATHER_API_CONF.api_key}`;

		fetch(url_Fetch)
			.then(response => response.json())
			.then( data => {

				const content_Api = `
						<span class="temp">${parseInt(data.main.temp)}°F <span class="text">${data.weather[0].description}</span></span>
						<span class="speed"><span class="text">wind speed</span> ${parseInt(data.wind.speed)}mph</span>
						<span class="humidity"><span class="text">humidity</span> ${data.main.humidity}%</span>
						<span class="course"><a href="https://www.springdalegolfnc.com/course-conditions" aria-label="page course conditions"><span class="text">Course Conditions</span></a></span>
					`
				append_Content.innerHTML = content_Api;
			});
	}

	//js animation parallax imagen
	const images = document.querySelectorAll('#home figure img:not(.no-parallax), #default figure img:not(.no-parallax),.parallax');
	
	new Ukiyo(images,{
			scale: 1.1,
			speed: 1.7,
			willChange: true
	});
	
	// SPLIT CURSIVE TITLE TEXT
	document.querySelectorAll('.text-animation').forEach(span => {
		let cleartext = span.textContent.trim();
		const chars = cleartext.split('').map((char , index)=> `<span class="letter" style="transition-delay: ${ index * 150 }ms">${char != " " ? char:"&nbsp;"}</span>`).join('');
		span.innerHTML = `<span class="words">${chars}</span>`;
	});


	//accordion Funcionality
	let normal_accordion = document.querySelectorAll("[data-accodion] .tab-js");
	normal_accordion.forEach( (item, i) => {
		item.addEventListener("click", (element) => {
			element.target.classList.toggle("active");
			element.target.nextElementSibling.classList.toggle("active");
		});

		if (i ==0) item.click()
	});

	// LBX class overflow
	LBX._instances.forEach(currentItem => {
		currentItem.beforeShow = () => document.querySelector("body").classList.add("no-scroll")
		currentItem.beforeClose = () => document.querySelector("body").classList.remove("no-scroll");
	});

	// table section
	const tablesResp = document.querySelectorAll('.capacity-chart__txt table,.tabs-table__item table');
	if (tablesResp.length) {
			tablesResp.forEach((tablei) => {
					let tableresponsive = document.createElement('div')
					tableresponsive.classList.add('tableHold')
					tablei.parentNode.insertBefore(tableresponsive, tablei)
					tableresponsive.append(tablei)
					const ths = tablei.querySelectorAll('tr:first-child > *')
					tablei.querySelectorAll('tr + tr').forEach((row) => {
							const tds = row.querySelectorAll('td')
							let i = 0
							for (i; i < tds.length; i++) {
									tds[i].setAttribute('data-label', ths[i].textContent)
							}
					})
					const rowHeads = tablei.querySelectorAll('tr td:first-child')
					rowHeads.forEach((ele) => {
							ele.addEventListener('click', (ev) => {
									ele.closest('tr').classList.toggle('active')
							})
					})
			})
	}

		//tabs table funcionality
		document.querySelectorAll('[data-tab]').forEach((btn, i) => {
			btn.addEventListener('click', e => {
					document.querySelectorAll('[data-tab]').forEach(b => b.classList.remove('active'));
					btn.classList.add('active');
	
					document.querySelectorAll('[data-section]').forEach(section => {
						section.classList.remove('active');
						if (btn.dataset.tab === section.dataset.section ) section.classList.add('active');
					});
	
			});
			
			if (i === 0) btn.click()
		});
	
		const select_faq = document.querySelector('[data-tabselect]');
		if (select_faq != null) {
			select_faq.addEventListener('change', e => {
				document.querySelectorAll('[data-section]').forEach(seccion => {
					seccion.classList.remove('active');
					if (select_faq.value === seccion.dataset.section) {
						seccion.classList.add('active');
					}
				});
			});
		}
	
})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	
	const section_Logo = document.querySelector(".header__logo img");
	const main_logo = site_url + 'assets/svg/Logo.svg';
	const main_logo_Scroll = site_url + 'assets/svg/Logo-Alte.svg'

	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				section_Logo.src = main_logo_Scroll;
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				section_Logo.src = main_logo_Scroll;
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			section_Logo.src = main_logo;
		}
		if (document.querySelector("#top-content") == null) {
			document.getElementById('header').classList.add('up');
			section_Logo.src = main_logo_Scroll;
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//animation of scroll vanilla JS
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from = window.pageYOffset
	var to = gotoTarget
	var duration = 1300;
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start

		if (from <= to) {
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {

			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft
	}
}

//class for scroll
let classtoscroll = document.querySelectorAll(".scroll-js , .btn-scroll");
if (classtoscroll) {
	classtoscroll.forEach(item =>{
		item.addEventListener("click", (e)=>{
			e.preventDefault();
			let sectiongoto = e.target.hash.split("#")[1];
			animateTo(sectiongoto)
			if (document.querySelector(".sub-menu__hold").classList.contains("open")) {
				document.querySelector(".sub-menu__hold").classList.remove("open")
			}
		});
	});
}

/* Subnav on mobile */
let submenuHold = document.querySelectorAll('.sub-menu__hold');
let allsublinks = document.querySelectorAll('.sub-menu a');
if(allsublinks.length > 1){
	allsublinks.forEach(ele=>{
		ele.addEventListener('click', function(ev){
			if(ele.classList.contains('active')){
				ev.preventDefault();
			}
		});
	});
	let toggleBtn = document.querySelector('.sub-menu__toggle');
	if(toggleBtn){
		//toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
		toggleBtn.addEventListener('click', function(){
			toggleBtn.parentElement.classList.toggle('open');
		});
	}
}else if(submenuHold.length > 0){
	submenuHold[0].classList.add('hidden');
}